import { useTranslation } from 'next-i18next'
import { Button } from '~/components/ui/button'
import { mapEmitter } from '~/domains/search/emitters/search.emitters'
import { useSearchSpaces } from '~/domains/search/hooks/use-search-spaces.hook'

export const NoSpacesFound = ({
	hasAlternatives,
}: {
	hasAlternatives?: boolean
}) => {
	const { t } = useTranslation()

	const { isMapVisible, setIsMapVisible, filters, setFilters } =
		useSearchSpaces()

	return (
		<div
			data-testid='no-spaces-found'
			className='flex flex-col items-start gap-6'
		>
			{hasAlternatives && filters.start ? (
				<>
					<h1 className='max-w-[400px] font-bold text-4xl'>
						{t('search:results.noResults.allCocoonsBooked.title')}
					</h1>

					<p>{t('search:results.noResults.allCocoonsBooked.body')}</p>
				</>
			) : (
				<>
					<h1 className='max-w-[400px] font-bold text-4xl'>
						{t('search:results.noResults.noCocoonMatchSearch.title')}
					</h1>

					<p>{t('search:results.noResults.noCocoonMatchSearch.body')}</p>

					<Button
						variant='outline'
						color='inherit'
						onClick={() => {
							setFilters({
								capacity: undefined,
								text: undefined,
								features: undefined,
								start: undefined,
								end: undefined,
								day: undefined,
								ne_latitude: undefined,
								ne_longitude: undefined,
								sw_latitude: undefined,
								sw_longitude: undefined,
							})

							if (!isMapVisible) {
								setIsMapVisible(true)
							} else {
								mapEmitter.emit('map.resetToZone')
								mapEmitter.emit('map.fitBounds')
							}
						}}
					>
						{t('search:results.noResults.noCocoonMatchSearch.btnLabel')}
					</Button>
				</>
			)}
		</div>
	)
}
